class PreviewUploadTest {
  constructor() {
    this.flag = Signalman.featureFlagFromCookie('pc_preview_upload_v19');
    if (this.flag) {
      this.dataLayerPush();
    }
  }

  dataLayerPush() {
    return window.dataLayer.push({
      event: 'ab_test_group',
      ab_test_name: '2024 12 09 catalog upload preview',
      ab_test_location: 'plp',
      ab_test_group: this.flag
    });
  }
}

jQuery(() => (ProductCatalog.PreviewUploadTest = new PreviewUploadTest()));
